import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/home/Home";
import Navbar from "./components/navbar/Navbar";
import About from "./components/about/About";
import Footer from "./components/footer/Footer";
import EnumberLayout from "./components/eNumber/EnumberLayout";
import RestaurantLayout from "./components/restaurant/RestaurantLayout";
import MosqueLayout from "./components/mosque/MosqueLayout";
import { Contact } from "./components/contact";

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/restaurants/:countryId" element={<RestaurantLayout />} />
        <Route path="/mosques/:countryId" element={<MosqueLayout />} />
        <Route path="/numbers" element={<EnumberLayout />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
